import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 md:px-6">
      <span className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
        <i className="ri-file-list-3-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
        Page not found
      </h1>
      <p className="mt-3 text-foreground-600 max-w-md leading-relaxed">
        The page you are looking for does not exist or may have been moved.
        Head back to browse the fan merchandise categories.
      </p>
      <Link
        to="/"
        className="whitespace-nowrap mt-7 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-home-4-line"></i>
        Back to home
      </Link>
    </div>
  );
}